import { useAuth } from '@/src/context/AuthContext';
import { useTheme } from '@/src/context/ThemeContext';
import { FeedbackType, SubmitFeedbackUseCase } from '@/src/domain/usecases/SubmitFeedbackUseCase';
import { useTranslation } from '@/src/i18n';
import { FeedbackScreen } from '@/src/presentation/screens/FeedbackScreen';
import { platformAlert } from '@/src/core/utils/platformAlert';
import { logger } from '@/src/core/utils';
import { APP_VERSION } from '@/src/core/config/appVersion';
import { useState } from 'react';

const submitFeedbackUseCase = new SubmitFeedbackUseCase();

export default function FeedbackContainer() {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const { user } = useAuth();

  const [selectedType, setSelectedType] = useState<FeedbackType>('general');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const appVersion = APP_VERSION || undefined;

  const handleSubmit = async () => {
    if (!user || !message.trim()) return;

    try {
      setSubmitting(true);
      await submitFeedbackUseCase.execute({
        userId: user.id,
        userEmail: user.email,
        type: selectedType,
        message,
        appVersion,
      });
      setMessage('');
      setSelectedType('general');
      platformAlert(t('feedback.successTitle'), t('feedback.successMessage'));
    } catch (error) {
      logger.error('Feedback', 'Failed to submit feedback', { error });
      platformAlert(t('common.error'), t('errors.failedToLoad'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <FeedbackScreen
      selectedType={selectedType}
      message={message}
      submitting={submitting}
      onTypeChange={setSelectedType}
      onMessageChange={setMessage}
      onSubmit={handleSubmit}
      colors={colors}
    />
  );
}
